// extracted by mini-css-extract-plugin
export default {"root":"Badges_root__wgim+","badge":"Badges_badge__ugrgS","badgeNew":"Badges_badgeNew__8WG-W"};